import * as Yup from "yup";

const BrandSchema = (isEdit = false) => Yup.object().shape({
  code: Yup.string()
    .label("Code")
    .required()
    .max(50),
  name: Yup.string()
    .label("Brand")
    .required()
    .max(255),
  icon: Yup.mixed().label("Icon").when([], {
    is: () => isEdit,
    then: (schema) => schema.nullable(),
    otherwise: (schema) => schema.required(),
  }),
});

export default BrandSchema
